import type React from 'react';

import { useGetLists } from '@vlabs/api/luna-api/client';
import type { ListId } from '@vlabs/api/luna-api/model';
import { routes } from '@vlabs/shared/navigation/routes';
import { Control } from '@vlabs/uikit';
import { generatePath } from 'react-router-dom';

import st from './ListLink.module.sass';

interface ListLinkProps {
  listIds?: ListId[];
}

function ListLink({ listIds = [] }: ListLinkProps): React.JSX.Element {
  const { data } = useGetLists(
    { list_ids: listIds },
    { query: { enabled: listIds.length > 0 } },
  );
  const lists = data?.lists ?? [];

  if (!listIds.length) return <div>-</div>;

  return (
    <div className={st.ListLink}>
      {listIds.map((listId, index) => (
        <Control.Link
          data-testid={`listLink${index + 1}`}
          key={listId}
          // @ts-expect-error lack routes types
          to={generatePath(routes.lists.read, { listId })}
        >
          {lists.find(({ list_id }) => list_id === listId)?.user_data ?? listId}
        </Control.Link>
      ))}
    </div>
  );
}

export { ListLink };
